import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestRevisionGet = {
    path: "/revision/:hash",
    method: RouteHttpVerb.GET
};
